import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/merchantevents`;
const merchantHistoryResource = `/api/v1/merchanthistories`;

export default {
  getMerchantEvents(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/merchant-events`, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantHistories(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${merchantHistoryResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  deleteMerchantHistory(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${merchantHistoryResource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
};
